import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid, Button } from '@material-ui/core';
import styles from "../setting.module.css";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSelector } from "react-redux";
import Alert from '../../../components/UI/alert'

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: '#23AFC4',
        color: 'white',
        width: '17.3rem',
        marginTop: '2.75rem',
        marginBottom: '1.12rem',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#23AFC4',
            color: 'white',
        },
    },
}));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    height: 440,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    p: 4
};

let ChangePasswordSchema = Yup.object().shape({
    currentPassword: Yup.string()
        .min(8, 'Password has to be 8 or more characters with a mix of letters & numbers')
        .required(
            'Password has to be 8 or more characters with a mix of letters & numbers'
        ),
    newPassword: Yup.string()
        .min(8, 'Password has to be 8 or more characters with a mix of letters & numbers')
        .required(
            'Password has to be 8 or more characters with a mix of letters & numbers'
        ),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords don’t match')
        .required(
            'Password has to be 8 or more characters with a mix of letters & numbers'
        ),
});

export default function AccountModal(props) {
    const axios = useAxiosPrivate()
    const { setOpen, open, setOpenedAccount, setSuccess } = props
    const email = useSelector((state) => state.auth.email);
    const classes = useStyles();
    const initialValues = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    }
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "success",
        message: "",
    });
    useEffect(() => {
        setOpenedAccount(false)
        // eslint-disable-next-line
    }, [open]);
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    const [showPassword2, setShowPassword2] = useState(false);
    const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
    const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);

    const [showPassword3, setShowPassword3] = useState(false);
    const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
    const handleMouseDownPassword3 = () => setShowPassword3(!showPassword3);

    const submit = async (e) => {
        try {
            await axios.post('/user/change_password', {
                email: email,
                password: e.currentPassword,
                new_password: e.newPassword,
            });
            setSuccess(true)
        } catch (error) {
            if (error.response && error.response?.data) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: error.response?.data?.message,
                });
                setTimeout(() => {
                    setAlert({
                        showAlert: false,
                        severity: 'error',
                        message: error.response?.data?.message,
                    });
                }, 5000);
            } else {
                setAlert({
                    showAlert: true,
                    severity: 'error',
                    message: 'Something was wrong!',
                });
                setTimeout(() => {
                    setAlert({
                        showAlert: false,
                        severity: 'error',
                        message: 'Something was wrong!',
                    });
                }, 5000);
            }
        }

    };

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container style={{ marginTop: "2rem" }}>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "-3rem" }}>
                            <ModalCloseButton onClick={() => setOpen(false)} style={{ position: "static" }} />
                        </Grid>
                        <Grid item md={12}>
                            <Formik
                                initialValues={initialValues}
                                onSubmit={submit}
                                validationSchema={ChangePasswordSchema}
                            >
                                {({ dirty, isValid }) => {
                                    return (
                                        <Form>
                                            <Grid container spacing={2} alignItems="center" justifyContent="center" style={{ marginTop: "0.5rem" }}>
                                                <Grid item md={10}>
                                                    <Field
                                                        name='currentPassword'
                                                        label='Current Password'
                                                        component={TextField}
                                                        variant='outlined'
                                                        fullWidth
                                                        margin='dense'
                                                        type={showPassword2 ? 'text' : 'password'}
                                                        style={{
                                                            fontFamily: 'Poppins',
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position='end'>
                                                                    <IconButton
                                                                        aria-label='toggle password visibility'
                                                                        onClick={handleClickShowPassword2}
                                                                        onMouseDown={handleMouseDownPassword2}
                                                                    >
                                                                        {showPassword2 ? (
                                                                            <VisibilityIcon />
                                                                        ) : (
                                                                            <VisibilityOffIcon />
                                                                        )}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    ></Field>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} alignItems="center" justifyContent="center">
                                                <Grid item md={10} style={{ marginTop: "1rem" }}>
                                                    <Field
                                                        style={{ fontFamily: 'Poppins' }}
                                                        name='newPassword'
                                                        label='New Password'
                                                        component={TextField}
                                                        variant='outlined'
                                                        fullWidth
                                                        margin='dense'
                                                        type={showPassword ? 'text' : 'password'}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position='end'>
                                                                    <IconButton
                                                                        aria-label='toggle password visibility'
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                    >
                                                                        {showPassword ? (
                                                                            <VisibilityIcon />
                                                                        ) : (
                                                                            <VisibilityOffIcon />
                                                                        )}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    ></Field>
                                                    <p className={styles.passwordText}>
                                                        Use 8 or more characters with a mix of letters {'&'} numbers
                                                    </p>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} alignItems="center" justifyContent="center">
                                                <Grid item md={10} style={{ marginTop: "-1rem" }}>
                                                    <Field
                                                        name='confirmPassword'
                                                        label='Confirm Password'
                                                        component={TextField}
                                                        variant='outlined'
                                                        fullWidth
                                                        margin='dense'
                                                        type={showPassword3 ? 'text' : 'password'}
                                                        style={{
                                                            fontFamily: 'Poppins',
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position='end'>
                                                                    <IconButton
                                                                        aria-label='toggle password visibility'
                                                                        onClick={handleClickShowPassword3}
                                                                        onMouseDown={handleMouseDownPassword3}
                                                                    >
                                                                        {showPassword3 ? (
                                                                            <VisibilityIcon />
                                                                        ) : (
                                                                            <VisibilityOffIcon />
                                                                        )}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    ></Field>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} justifyContent="flex-end">
                                                <Grid item md={3} style={{ marginTop: "-2rem" }}>
                                                    <Button
                                                        fullWidth
                                                        size='large'
                                                        type='submit'
                                                        className={classes.button}
                                                        disabled={!dirty || !isValid}
                                                        style={isValid && isValid ? {
                                                            fontSize: '0.9rem',
                                                            lineHeight: '1.25rem',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 300,
                                                            fontStyle: 'normal',
                                                            width: 85,
                                                            height: 38,
                                                            backgroundColor: "#0F9BB0",
                                                            color: "white",
                                                            textTransform: "none"
                                                        } : {
                                                            fontSize: '0.9rem',
                                                            lineHeight: '1.25rem',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 300,
                                                            fontStyle: 'normal',
                                                            width: 85,
                                                            height: 38,
                                                            backgroundColor: "#77D0D1",
                                                            color: "white",
                                                            textTransform: "none"
                                                        }}
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    );
                                }}
                            </Formik>
                        </Grid>
                    </Grid>
                    <Alert showAlert={alert.showAlert} severity={alert.severity} message={alert.message} setAlert={setAlert} />
                </Box>
            </Modal>
        </div>
    );
}